// src/components/website/Gallery.jsx
import React, { useState } from 'react';
import { 
  XMarkIcon, 
  ChevronLeftIcon, 
  ChevronRightIcon,
  PhotoIcon
} from '@heroicons/react/24/outline';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // 📸 YOUR GALLERY IMAGES
  // Add your photos here — one line per photo
  const images = [
    {
      id: 1,
      title: 'Annual Day Celebration',
      image: '/images/gallery/01.jpeg'
    },
    {
      id: 2,
      title: 'Annual Day',
      image: '/images/gallery/02.jpeg'
    },
    {
      id: 3,
      title: 'Pass-out Ceremony',
      image: '/images/gallery/03.jpeg'
    },
    {
      id: 4,
      title: 'Student Group Photo',
      image: '/images/gallery/04.jpeg'
    },
    {
      id: 5,
      title: '',
      image: '/images/gallery/05.jpeg'
    },
    {
      id: 6,
      title: 'winning Prize',
      image: '/images/gallery/06.jpeg'
    },
    {
      id: 7,
      title: 'Winning Prize',
      image: '/images/gallery/07.jpeg'
    }
  ];

  const openModal = (index) => {
    setCurrentIndex(index);
    setSelectedImage(images[index]);
  };

  const closeModal = () => setSelectedImage(null);

  const navigateImage = (direction) => {
    const newIndex = currentIndex + direction;
    if (newIndex >= 0 && newIndex < images.length) {
      setCurrentIndex(newIndex);
      setSelectedImage(images[newIndex]);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <div className="inline-block bg-white/20 backdrop-blur-lg rounded-full px-6 py-2 mb-4">
            <span className="text-sm font-medium">📸 School Gallery</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Gallery</h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Explore the vibrant life at Vidya Bharati School through our photo gallery.
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {images.map((image, index) => (
              <div
                key={image.id}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer bg-white"
                onClick={() => openModal(index)}
              >
                <div className="relative overflow-hidden h-64">
                  <img
                    src={image.image}
                    alt={image.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://via.placeholder.com/800x600?text=Image+Not+Found';
                    }}
                  />
                  {/* Title overlay on hover */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition duration-300">
                    <div className="absolute bottom-0 left-0 right-0 p-4">
                      <h3 className="font-bold text-lg text-white">{image.title}</h3>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Empty state */}
          {images.length === 0 && (
            <div className="text-center py-16 bg-white rounded-2xl shadow-sm">
              <PhotoIcon className="h-16 w-16 text-gray-300 mx-auto mb-4" />
              <h3 className="text-xl font-bold text-gray-800">No photos yet</h3>
              <p className="text-gray-500">Check back soon for new photos</p>
            </div>
          )}
        </div>
      </section>

      {/* Simple Image Viewer */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4">
          <button
            onClick={closeModal}
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition z-10 bg-black/50 p-2 rounded-full"
          >
            <XMarkIcon className="h-8 w-8" />
          </button>

          <button
            onClick={() => navigateImage(-1)}
            className="absolute left-4 text-white hover:text-gray-300 transition z-10 disabled:opacity-30 bg-black/50 p-3 rounded-full"
            disabled={currentIndex === 0}
          >
            <ChevronLeftIcon className="h-8 w-8" />
          </button>

          <button
            onClick={() => navigateImage(1)}
            className="absolute right-4 text-white hover:text-gray-300 transition z-10 disabled:opacity-30 bg-black/50 p-3 rounded-full"
            disabled={currentIndex === images.length - 1}
          >
            <ChevronRightIcon className="h-8 w-8" />
          </button>

          <div className="max-w-5xl w-full">
            <img
              src={selectedImage.image}
              alt={selectedImage.title}
              className="w-full max-h-[80vh] object-contain rounded-2xl"
            />
            <div className="text-white text-center mt-6">
              <h3 className="text-2xl font-bold">{selectedImage.title}</h3>
              <p className="text-xs text-gray-500 mt-2">
                {currentIndex + 1} / {images.length}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;